export default __webpack_public_path__ + "static/media/quiz.256ac0b6.png";